import styles from './Main.module.css';
import React, { ReactNode } from 'react';
import cn from 'classnames';

import { usePanel } from '$hooks/usePanel';

export function Main({ children }: { children?: ReactNode | ReactNode[] }) {
    const headerWrapperElement = document.getElementById('header-wrapper');

    const headerElement = headerWrapperElement?.children.namedItem('header');
    const subHeaderElement = headerWrapperElement?.children.namedItem('sub-header');

    const isHeaderNotEmpty = !!headerElement?.children.length;
    const isSubHeaderNotEmpty = !!subHeaderElement?.children.length;

    return (
        <div
            id="main"
            className={styles.main}
            style={{
                paddingTop:
                    isSubHeaderNotEmpty && isHeaderNotEmpty
                        ? headerElement.scrollHeight + subHeaderElement.scrollHeight
                        : isHeaderNotEmpty
                          ? headerElement.scrollHeight
                          : isSubHeaderNotEmpty
                            ? subHeaderElement?.scrollHeight
                            : undefined
            }}
        >
            {children}
        </div>
    );
}

Main.Content = function MainContent({ children }: { children?: ReactNode | ReactNode[] }) {
    const { panel } = usePanel();
    return (
        <div
            id="main-content"
            className={cn(
                styles.content,
                panel ? styles.hasOpenPanel + ' has-open-panel' : undefined
            )}
        >
            {children}
        </div>
    );
};
